import { default as MuiPagination } from '@mui/material/Pagination';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  pageChange: (page: number) => void;
}

export const Pagination = ({
  currentPage,
  totalPages,
  pageChange,
}: PaginationProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.only('xs'));
  const paginationOptions = {
    siblingCount: isMobile ? 0 : 1,
    boundaryCount: isMobile ? 1 : 2,
    size: isMobile ? 'medium' : 'large',
  };

  const handlePageChange = (_: unknown, value: number) => {
    if (pageChange) {
      pageChange(value);
    }

    window.scrollTo(0, 0);
  };

  return (
    <MuiPagination
      count={totalPages}
      page={currentPage}
      onChange={handlePageChange}
      siblingCount={paginationOptions.siblingCount}
      boundaryCount={paginationOptions.boundaryCount}
      size={paginationOptions.size as 'medium' | 'large' | 'small'}
    />
  );
};
